export { default } from "./WealthboxForm";
